import React from 'react';

export default function Logo({ compact = false, clair = true, className = '' }) {
  const texte = clair ? '#FFFFFF' : '#0B1E33';
  const second = clair ? '#8FA3B7' : '#6E7A87';
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} aria-label="BATI SELECT TP">
      <svg width="42" height="42" viewBox="0 0 104 104" aria-hidden="true" className="shrink-0">
        <rect width="104" height="104" rx="9" fill="#F5B301" />
        <rect x="6" y="6" width="92" height="92" rx="5" fill="#0B1E33" />
        <circle cx="17" cy="17" r="3.2" fill="#F5B301" />
        <circle cx="87" cy="17" r="3.2" fill="#F5B301" />
        <circle cx="17" cy="87" r="3.2" fill="#F5B301" />
        <circle cx="87" cy="87" r="3.2" fill="#F5B301" />
        <text
          x="52" y="71" textAnchor="middle"
          fontFamily="Anton, Impact, sans-serif" fontSize="46" fill="#FFFFFF"
        >
          BS
        </text>
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className="block font-display text-[19px] tracking-wide" style={{ color: texte }}>
            BATI SELECT
          </span>
          <span
            className="block font-cond font-semibold text-[11px] tracking-[0.34em] mt-[3px]"
            style={{ color: second }}
          >
            TP · ALFORTVILLE
          </span>
        </span>
      )}
    </span>
  );
}
